import {Component, Watch, Prop} from 'vue-property-decorator';
import { Table } from '@/components/bwaff';
import TableScrollMixin from './table-scroll-mixin';
import selectRow, { normalizeId }  from './table-selection';
import scrollbarWidth from '@/components/helpers/scrollbar-width'

import { debounce, get, cloneDeep } from 'lodash';

import { mixins } from 'vue-class-component';
import { VNode } from 'vue';
import DimensionsMixin from '@/components/datatable/dimensions-mixin';
import ReportMetricsMixin from '@/views/reports/mixins/report-metrics-mixin';
import UrlMixin from '@/components/query/url-mixin';

import { METRICS_CUSTOM_COLUMN, METRICS_CUSTOM_EVENT, METRICS_CUSTOM_EVENT_REVENUE, METRICS_CUSTOM_EVENT_HIDDEN_REVENUE } from '@/services/constants/report';

@Component
export default class DataTable extends mixins(Table, TableScrollMixin, DimensionsMixin, ReportMetricsMixin, UrlMixin) {
  @Prop({default:0}) treeLevel!: number;
  @Prop(String) type!: string;
  @Prop(Array) treeView!: string[];
  @Prop(Boolean) treeRoot!: boolean;
  @Prop(Array) treePath!: string[];
  @Prop(Object) tree!: any;
  @Prop(Boolean) resize!: boolean;
  @Prop(Boolean) statusColumn!: boolean;
  @Prop({default: (i: any) => i}) customFilter!: Function;
  @Prop({default: (i: any) => i}) customSort!: Function;
  @Prop({default: null}) hideResizers!: number[];
  @Prop({default: true}) multiSelect!: boolean;
  @Prop({default: false}) simple!: boolean;
  @Prop({default: false}) fillHeight!: boolean;
  @Prop({default: false}) generateIds!: boolean;
  @Prop({default: null}) idPrefix!: string;
  @Prop({default: false}) refreshed!: boolean;
  @Prop({default: false}) freezed!: boolean;
  @Prop() rootGrouping!: string;
  @Prop() emptyRows!: { [type: string]: any};
  @Prop() translateHeader!: boolean;

  //non-reactive by design
  resizerData: any;

  get pHideResizers(): number[] {
    return this.hideResizers 
      ? this.hideResizers
      //@ts-ignore
      : this.hasSelectAll
        ? [0, 1]
        : [0];
  }

  tableSelectedItemsLength: number = 0;
  itemsCount: number = 0;

  // this hack used because
  // this.$store.state.tableSelectedItems.length cause to redraw header 
  // even if not changed
  @Watch('$store.state.table.selectedItems', {
    immediate: true
  })
  onStateTableSelectedItemsChanged(value: any[], oldValue: any[]) {
    if(!oldValue || value.length !== oldValue.length) {
      this.tableSelectedItemsLength = value.length;
    }
  }

  get validScrolledItemsLength() {
    return this.scrolledItems
      .filter((item) => item[this.rowKey] /*&& item[this.rowKey] !== 'Unknown'*/).length;
  }

  pIsSelectedAll: boolean = false;

  get isSelectedAll() {
    return this.tableSelectedItemsLength == this.validScrolledItemsLength && this.validScrolledItemsLength !== 0;
  }

  set isSelectedAll(value: boolean) {
    if(value) {
      if(this.isVirtualScroll) {
        let selected = this.scrolledItems.map((item: any) => ({
          [this.rowKey]: item[this.rowKey],
          DT_RowName: item.DT_RowName,
          DT_RowStatus: item.DT_RowStatus,
          DT_RowUrl: item.DT_RowUrl,
          grouping: this.grouping,
        }));
        
        this.$emit('row-selected', selected);
        this.bus.emit('refresh-table-selection');
        
        this.$nextTick(() => {
          this.registerScrollEventHandlers();
        });
        
      } else {
        selectRow(new MouseEvent('click'), this, this.scrolledItems);
      }
      
    } else {
      this.bus.emit('clear-table-selection');
      selectRow(null, this, null);      
    }
  }

  @Watch('isSelectedAll')
  onIsSelectedAllChanged(value: boolean, oldValue: boolean) {
    if(value !== oldValue) {
      this.pIsSelectedAll = value;
    }
  }

  beforeUpdate(){
    this.$emit('updated');
  }
  
  updated() {
    this.$emit('updated');

    if(!this.isVirtualScroll) {
      // this.$nextTick(() => {
      //   selecterRowsUpdateDebounced
      // });
      this.selecterRowsUpdateDebounced();
    }
  }
  
  get selecterRowsUpdateDebounced() {
    return debounce(this.selecterRowsUpdate, 100);
  }

  selecterRowsUpdate() {
    if(!this.freezed) {
      const rows = this?.$el?.getElementsByClassName('datatable-row__data-row');
      this.scrollCleanup(rows);
    }
  }

  @Watch('scrolledRowsCache')
  onScrolledRowsCache() {
    if(this.isVirtualScroll && this.overflow) {
      this.registerScrollEventHandlers();
    }
  }

  @Watch('selected_metrics')
  onSelectedMetricsChanged() {
    this.resetResizer();
  }

  mounted(){
    this.bus.on('tree-items-updated', this.onBusTreeItemsUpdated);
    this.bus.on('tree-view-changed', this.onBusTreeViewChanged);
    this.bus.on('datatable-resizer-data-changed', this.onBusDatatableResizerDataChanged);

    this.$on('treeExpandClick', (item: any) => {
      if(this.treeView.length) 
        this.$emit('tree', item, this.grouping)
    });
  }

  beforeDestroy() {
    this.bus.off('tree-items-updated', this.onBusTreeItemsUpdated);
    this.bus.off('tree-view-changed', this.onBusTreeViewChanged);
    this.bus.off('datatable-resizer-data-changed', this.onBusDatatableResizerDataChanged);

    this.$off('treeExpandClick');
  }

  onBusDatatableResizerDataChanged(data: any) {
    this.resizerData = cloneDeep(data);
  }

  onBusTreeItemsUpdated() {
    this.$nextTick(() => {
      this.onWindowResize();
    });
    
    if(this.isVirtualScroll) {
      this.$nextTick(() => {
        this.updateRowsHeight();
      });
    }
  }

  onBusTreeViewChanged() {
    //this.resetResizer(true);
  }

  resetResizer() {
    return new Promise<void>((resolve) => { 
      this.$nextTick(() => {
        resolve();
      });
    });
  }
  
  beginMetricRecord() {
    return new Promise<void>((resolve) => {
      setTimeout(() => {

        this.resetResizer()
          .catch((error) => {
          })
          .finally(() => {
            setTimeout(() => {
              resolve();
            }, 30);
          });
      });
    });
  }

  filteredItemsImpl() {
    return this.items;
  }

  pProcessedHeaders: any[] = [];

  @Watch('processedHeaders', { immediate: true })
  onProcessedHeadersChanged(value: any[], oldValue: any[]) {
    const check = () => {
      if(!oldValue) {
        return true;
      } else {
        const a = value.map((item) => item.value).join();
        const b = oldValue.map((item) => item.value).join();

        if(a !== b) {
          return true;
        }
      }

      return false;
    };

    if(check()) {
      this.pProcessedHeaders = value;
    } 
  }  

  orderItems(obj: any): any[] {
      let result: any[] = [];
      this.pProcessedHeaders.map((e: any) => e.value).forEach((k: any) => {
        if (obj[k] !== undefined) {
          result.push( this.formatCellValue(k, obj[k], obj) );
        } else {
          result.push(this.$createElement('td', []));
        }
      });
      return result;
  }

  formatCellValue(value: string, data: any, obj: any) {
    if (data && data.tag !== 'td' || !data) {
      if (typeof data === 'string' && /^<i>[^<>]+<\/i>$/.test(data))  //вставляем в таблицу html только если внутри форматирование курсивом
        data = this.$createElement('td', { domProps: { innerHTML: data } }, []);
      else
        data = this.$createElement('td', data, []);
    }

    const hasMark = obj.DT_RowMark || obj.DT_RowMark === 0

    if (hasMark && obj.DT_RowName === obj[value]) {
      const formatter: Function = (this.formatters as any).mark;
      data = formatter({ vtag: this.$createElement, component: data, ctx: this, data: obj, key: value, colors: this.$colors });
    }

    if (this.formatters?.[value]) {
      const formatter: Function = (this.formatters as any)[value];
      return formatter({ vtag: this.$createElement, component: data, ctx: this, data: obj, key: value, colors: this.$colors, treeView: this.treeView });
    }

    if (value.startsWith(METRICS_CUSTOM_EVENT)) {
      const formatter: Function = (this.formatters as any)[METRICS_CUSTOM_EVENT];
      return formatter({ vtag: this.$createElement, component: data, ctx: this, data: obj, key: value });
    }

    if (value.startsWith(METRICS_CUSTOM_EVENT_REVENUE)) {
      const formatter: Function = (this.formatters as any)[METRICS_CUSTOM_EVENT_REVENUE];
      return formatter({ vtag: this.$createElement, component: data, ctx: this, data: obj, key: value });
    }

    if (value.startsWith(METRICS_CUSTOM_EVENT_HIDDEN_REVENUE)) {
      const formatter: Function = (this.formatters as any)[METRICS_CUSTOM_EVENT_HIDDEN_REVENUE];
      return formatter({ vtag: this.$createElement, component: data, ctx: this, data: obj, key: value });
    }
 
    if (value.startsWith(METRICS_CUSTOM_COLUMN)) {
      const formatter: Function = (this.formatters as any)[METRICS_CUSTOM_COLUMN];
      const column = this.$store.getters.getCustomColumns[(value.slice(METRICS_CUSTOM_COLUMN.length))]

      if (column) {
        const { format, decimalPlaces } = column
        return formatter({
          vtag: this.$createElement,
          component: data,
          ctx: this,
          data: obj,
          key: value,
          format,
          decimal: decimalPlaces,
          colors: this.$colors
        });
      }

    }

    return  data
  }

  genHeader (header: any, key: any) {
    const vtag = this.$createElement;
    const array = [
        this.$scopedSlots.headerCell
            ? this.$scopedSlots.headerCell({ header })
            : this.translateHeader 
              ? header[(this as any).headerText] || this.reportMetricsName(header.value)
              : header[(this as any).headerText]
    ];
    const { genHeaderData } = this as any;
    const headerData = genHeaderData(header, array.map((e: any)=> vtag('span', {class:{'header-content':true}}, e)), key);
    let params = headerData[0];
    params.attrs = {
      ...params.attrs,
      'data-metric': header.value
    };

    if(header.disableSortChange) {
      params.class.push('column--disable-sort-change');  
    }
    
    const children = headerData[1];

    //console.log('headerData', header);

    return vtag('th', params, children);
  }

  get headerCheckbox() {
    const vtag = this.$createElement;
    return vtag('v-checkbox', {
      props: {
          inputValue: false,
          primary: true,
          hideDetails: true,
          value: this.pIsSelectedAll,
          color: 'no-color',
          ripple: false,
          transition: false
      },
      attrs:{},
      on: {
        change: (ev: boolean) => {
          this.isSelectedAll = !!ev;
        },
      }
    });
  }

  get THead() {
    const vtag = this.$createElement;

    if ((this as any).hideHeaders) return; // Exit Early since no headers are needed.

    let children = [];

    if (this.$scopedSlots.headers)
    {
      const row = this.$scopedSlots.headers({
        headers: (this as any).processedHeaders,
        indeterminate: (this as any).indeterminate,
        all: (this as any).everyItem
      });
      children = [
        (this as any).hasTag(row, 'th') ?
          (this as any).genTR(row) : row,
        (this as any).genTProgress()
      ]
    } else {
      const row: VNode[] = (this as any)
        .processedHeaders
        .map((o: any, i: any) => (
          (this as any).genHeader(o, (this as any).headerKey ? o[(this as any).headerKey] : i)
        ));

      if ((this as any).hasSelectAll && (!this.treeView || !this.treeView.length || !this.treePath)) {       
        row.unshift(
          vtag('th', 
            {
              attrs: {
                style: 'width:22px'
              }
            }, 
            [ this.headerCheckbox ]
          )
        );
      }

      if(this.statusColumn)
        row.unshift(vtag('th', ['']));

      // if( this.selectable && !(this as any).hasSelectAll)
      //   row.unshift(vtag('th',{ style: { textAlign: 'left', width:'26px' } },[vtag('v-icon',['more_vert'])]));

      if( this.actions && this.actions.length)
        row.push(vtag('th',{ style: { textAlign: 'right' } },[vtag('v-icon',['drag_handle'])]));

      if (this.treeView && this.treeView.length) row.unshift(vtag('th'));

      row.push(vtag('th', {class: 'datatable-row__right-filler'}));
      
      if(scrollbarWidth && this.isScrollVisible) {
        row.push(vtag('th', 
          {
            style: {
              width: `${scrollbarWidth}px !important`,
              'max-width': `${scrollbarWidth}px !important`,
              'min-width': `${scrollbarWidth}px !important`,
            },
            class: 'datatable__scrollbar-filler',
          }
        ));
      }
      

      children = [ this.treeLevel ? '' : (this as any).genTR(row), this.loading ? (this as any).genTProgress() : '']
    }


    return vtag('thead', [children])
  }

  rowColCount: number = 0;

  fixNonReactiveElements() {
    if(this.simple) {
      return;
    }
    
    let selected: any = this?.$el?.querySelectorAll('.datatable__row-selected, .datatable__row-selected .fa-check-square') || [];
    
    //fix NodeList issue for old browsers
    if(!selected.forEach) {
      selected = Array.from(selected);
    }

    selected.forEach((e: HTMLElement)=>{
        e.classList.remove('datatable__row-selected');
        if(e.classList.contains('fa-check-square'))
        {
            e.classList.remove('fa-check-square');
            e.classList.add('fa-square');
        }
    });

    if(!this.refreshed) {
      this.$nextTick(() => {
        this.onWindowResize();
      });
    }
  }

  get isTreeView() {
    return this.treeView 
      && Array.isArray(this.treeView) 
      && this.treePath 
      && this.treePath.length;
  }

  pGenFilteredItems(scrolledItems: any[]) {
    //console.log('pGenFilteredItems');
    const rows: any[] = [];
    let rowColCount = 0;

    this.fixNonReactiveElements();

    //@ts-ignore
    const vtag = this.$createElement;
    let itemsLength = this.items.length;

    let getCheckBoxFunc = this.isVirtualScroll 
      ? (item: any) => {
          return {
              props: {
                inputValue: false,
                primary: true,
                hideDetails: true,
                ripple: false
              },
              attrs:{
                'data-id': item[this.rowKey]
              }
          }
        }
      : (item: any) => {
        return {
              props: {
                inputValue: false,
                primary: true,
                hideDetails: true,
                ripple: false
              },
              attrs:{
                'data-id': item[this.rowKey]
              },
              on: {
                click: (ev: MouseEvent) => {
                  ev.stopPropagation();
                  selectRow(ev, this, item);
                }
              },
              nativeOn: {
                dblclick: (ev: MouseEvent) => {
                  ev.preventDefault();
                  ev.stopPropagation();
                }
              },
          }
      };

      let getExpandButtonFunc = this.isVirtualScroll
        ? function() {
            return {
              class: {
                'datatable__row-expand': true
              },
              style: {
                padding: '0px 6px',
                textAlign: 'center'
              }
            }
          }
        : (item: any) => {
          return {
            class: {
              'datatable__row-expand': true
            },
            on: {
              click: (ev: MouseEvent) => {
                ev.stopPropagation();

                if(this.treeView.length)  {
                  this.$emit('tree', item, this.grouping)
                }
              },
              dblclick: (ev: MouseEvent) => {
                ev.preventDefault();
                ev.stopPropagation();
              }
            },
            nativeOn: {
              dblclick: (ev: MouseEvent) => {
                ev.preventDefault();
                ev.stopPropagation();
              }
            },
            style: {
                padding: '0px 6px',
                textAlign: 'center'
            }}
        };

    let isTreeView = this.isTreeView;
    
    for (let index = 0; index < scrolledItems.length; ++index) {
      if (!scrolledItems[index])
          break;

      let data = this.orderItems(scrolledItems[index]);
      let item = scrolledItems[index];
      let select;

      if (isTreeView) {
        let icon = this.tree && this.tree[item[this.rowKey]] ? 'fas fa-chevron-down' : 'fas fa-chevron-right';
          if(!this.treeView.length) {
              select = vtag('td', getExpandButtonFunc(item));
          } else {
              //render expand
              const chevron = vtag('v-btn',
                {
                  style: {
                    left: `${(this.treeLevel) * 14}px`
                  },
                  attrs: {
                    style: 'width: 20px; height: 20px; margin: 0;',
                  },
                  class: {'tree-box-chevron': true}
                },
                [
                  vtag('ui-icon', {props: { icon, size: !this.treeView.length ? '6' : '12'}})
                ]
              );
              select = vtag('td', getExpandButtonFunc(item),
                [
                  chevron,
                ]
              );
          }
      } else {
        let checkBox = this.multiSelect // item[this.rowKey] !== 'Unknown'
          ? [ vtag('v-checkbox', getCheckBoxFunc(item)) ]
          : [];
        
        //render checkbox
        select = vtag('td', {
              style: {
                  padding: '0px 6px',
                  textAlign: 'center'
              }
          }, checkBox
        );
      }

      //@ts-ignore
      if (this.selectable && select && this.hasSelectAll) {
        data.unshift(select);
      }
        

      //Row level actions
      if (this.actions && this.actions.length) {
        let actions = vtag('td', {
          class: {
            'data-table__actions': true
          },
          style: { textAlign: 'right', padding:'0px' },
          props: {
            on:{
              click:function(ev: any){
                ev.stopPropagation();
              }
            }
          }
        }, this.actions.map((C: any) => {
          return vtag(C, {
            props:{
              data: item
            }
          }, [])
        }));

        data.push(actions);

      }

      if(this.statusColumn)
        data.unshift(vtag('td', [this.formatCellValue('profit_status', item.profit_status, item)]));
      
      let row: any = null;

      if(!rowColCount) {
        rowColCount = data.length;
      }

      if(this.treeLevel > 0 && scrollbarWidth && this.isScrollVisible) {
        data.push(vtag('td', {attrs: {style: `width:${scrollbarWidth}px; max-width:${scrollbarWidth}px; min-width:${scrollbarWidth}px;`,}, class: 'datatable__scrollbar-filler'}))
      }

      data.push(vtag('td', {class: 'datatable-row__right-filler'}));

      // не думаю что накладные расходы на условия превысят расходы на вызов колбека
      if(!this.isVirtualScroll && this.selectable) {
         row = vtag('tr', {
          key: item[this.rowKey],
          class:{
            'datatable-row': true,
            'datatable-row__first': index == 0,
            'datatable-row__last': index == itemsLength - 1,
            'datatable-row__data-row': !this.isVirtualScroll
          },
          attrs:{
            'data-id': item[this.rowKey],
            'data-type': this.type,
          },
          on: {
            contextmenu: (ev: MouseEvent)=>{
              ev.preventDefault();
              ev.stopPropagation();
              
              selectRow(ev, this,  item, true, true, this.treeLevel);
            },
            click: (ev: MouseEvent) => {
              ev.stopPropagation();
              selectRow(ev, this, item, true, false, this.treeLevel);
            },
            dblclick: (ev: MouseEvent) => {
              const id = normalizeId(item[this.rowKey]);

              const normalizedItem = {
                ...item,
                [this.rowKey]: id,
                id: id
              };

              // if(normalizedItem[this.rowKey] !== 'Unknown') {
              //   this.bus.emit('row-report', normalizedItem, this.grouping);
              // }

              this.bus.emit('row-report', normalizedItem, this.grouping);
            }
          },
        },
        data);
      } else {
        row = vtag('tr', {
          key: item[this.rowKey],
          class:{
            'datatable-row': true,
            'datatable-row__first': index == 0,
            'datatable-row__last': index == itemsLength - 1,
            'datatable-row__virtual-scroll': this.isVirtualScroll
          },
          attrs:{
            'data-id': item[this.rowKey],
            'data-type': this.type,
          },
        },
        data);
      }

      rows.push(
        (this as any).hasTag(row, 'td') 
          ? (this as any).genTR(row, {
            key: (this as any).itemKey 
              ? item[(this as any).itemKey] 
              : index,
            //attrs: { active: (this as any).isSelected(item) }
          }) 
          : row
      );

      if (this.tree && this.tree[item[this.rowKey]]) {
        this.genTreeTable(item, rows);
      }
    }
    return { rows, rowColCount };
  }

  genFilteredItems () {
    if(this.isVirtualScroll) {
      if(this.scrolledRowsCache && this.vTabRevision === this.oldVTabRevision) {
        return this.scrolledRowsCache;
      }

  
      if(!this.rowsCache || !this.isInBorders) {     
        let i = Math.max(this.currentRow - this.upperIncrement, 0);
        let len = Math.min(this.currentRow + this.lowerIncrement, this.scrolledItems.length);
  
        this.scrolledItemsCache = this.scrolledItems.slice(i, len);
        let { rows, rowColCount } = this.pGenFilteredItems(this.scrolledItemsCache);
        this.rowColCount = rowColCount;
  
        this.rowsCache = rows;
        this.rowsCacheUpper = i;
        this.rowsCacheLower = len;
      }
  
      this.scrolledRowsCache = this.modifyRows(this.rowsCache);
      this.oldVTabRevision = this.vTabRevision;
      this.currentRenderedRow = this.currentRow;

      return  this.scrolledRowsCache;
    } else {
      let { rows, rowColCount } = this.mainModeFilteredItems;
      this.rowColCount = rowColCount;

      return rows; 
    }
  }

  get mainModeFilteredItems() {
    return this.pGenFilteredItems(this.scrolledItems);
  }

  //performance debug
  // @Watch('items') onitems() {console.log('items');}
  // @Watch('isVirtualScroll') onisVirtualScroll() {console.log('isVirtualScroll');}
  // @Watch('rowKey') onrowKey() {console.log('rowKey');}
  // @Watch('treeView') ontreeView() {console.log('treeView');}
  // @Watch('grouping') ongrouping() {console.log('grouping');}
  // @Watch('isTreeView') onisTreeView() {console.log('isTreeView');}
  // @Watch('multiSelect') onmultiSelect() {console.log('multiSelect');}
  // @Watch('selectable') onselectable() {console.log('selectable');}
  // @Watch('hasSelectAll') onhasSelectAll() {console.log('hasSelectAll');}
  // @Watch('actions') onactions() {console.log('actions');}
  // @Watch('statusColumn') onstatusColumn() {console.log('statusColumn');}
  // @Watch('rowColCount') onrowColCount() {console.log('rowColCount');}
  // @Watch('type') ontype() {console.log('type');}
  // @Watch('treeLevel') ontreeLevel() {console.log('treeLevel');}
  // @Watch('scrolledItems') onscrolledItems() {console.log('scrolledItems');}
  // @Watch('processedHeaders') onprocessedHeaders() {console.log('processedHeaders');}
  // @Watch('pProcessedHeaders') onpProcessedHeaders() {console.log('pProcessedHeaders');}
  

  genTreeTable(item: any, rows: any[]){
      const vtag = this.$createElement;
      //@ts-ignore
      const component = this.tree[item[this.rowKey]];
      //@ts-ignore
      const propsData = (component.componentOptions || {}).propsData || component.data.props;

      rows.push(vtag('tr', {class:{ 
        'tree-box-header': true,
        'tree-box--empty': this.emptyRows[item[this.rowKey]],
      }, style: {display: component ? '' : 'none'} }, [
          //@ts-ignore
          vtag('td', {attrs:{colspan: '200'}}, [vtag('div', {class: ['sub-report-title']}, [
              //@ts-ignore
              this.dimensions[propsData.type] || propsData.type
          ])])
      ]));
      rows.push(vtag('tr', {class:{ 
        'tree-box': true,
        'tree-box--empty': this.emptyRows[item[this.rowKey]],
      },style: {display: component ? '' : 'none'} }, [
          //@ts-ignore
          vtag('td', {attrs:{colspan: '200'}}, [component])
      ]));

      const id = normalizeId(item[this.rowKey]);

      const normalizedItem = {
        ...item,
        [this.rowKey]: id,
        id: id
      };

      rows.push(vtag('tr', {class:{ 'tree-box': true,  'tree-box-drilldown-button': true},style: {display: component ? '' : 'none'} }, [
        //@ts-ignore
        vtag('td', {attrs:{colspan: '200'}}, [
          vtag('div', {
            class: 'datatable__drilldown-button-wrapper',
          },
          [
            vtag('ui-button', {
              class: 'mt-0 mb-0 mr-0 datatable__drilldown-button',
              props: {
                //disabled: normalizedItem[this.rowKey] === 'Unknown',
                icon: 'far fa-random',
                text: `${this.t('Drilldown')} ${normalizedItem.DT_RowName}`
              },
              on: {
                click: () => {
                  this.$emit('drilldown-forward', normalizedItem, this.grouping);
                }
              }
            })
          ])
          
        ])
      ]));
  }

  genTFoot () {
    if (!this.footer)
      return;

    const vtag = this.$createElement;


    //@ts-ignore
    const row  = this.orderItems(this.footer);

    //@ts-ignore
    // if( this.selectable && !this.hasSelectAll && !this.footer.$prepend)
    //   row.unshift(vtag('td',{ style: { textAlign: 'left', width:'26px' } },[vtag('v-icon',['more_vert'])]));
    //@ts-ignore
    if (this.footer.$prepend) row.unshift(vtag('td',[this.footer.$prepend]));

    //@ts-ignore
    if( this.actions && this.actions.length && !this.footer.$append)
      row.push(vtag('td',{ style: { textAlign: 'right' } },[vtag('v-icon',['drag_handle'])]));

    //@ts-ignore
    if (this.footer.$append) row.unshift(vtag('td',[this.footer.$append]));

    //@ts-ignore
    if(this.hasSelectAll) {
      row.unshift(vtag('td',['']));
    }
    
    if(this.statusColumn) {
      row.unshift(vtag('td',['']));
    }

    row.push(vtag('td', {class: 'datatable-row__right-filler'}));
      
    if(scrollbarWidth && this.isScrollVisible) {
      row.push(vtag('td', 
        {
          style: {
            width: `${scrollbarWidth}px`,
            'max-width': `${scrollbarWidth}px`,
            'min-width': `${scrollbarWidth}px`,
          },
          class: 'datatable__scrollbar-filler',
        }
      ));
    }

    //@ts-ignore
    const children = this.genTR(row);
    return vtag('tfoot', [children])
  }

  sort (index: any) {
    //@ts-ignore
    const { sortBy, descending } = this.computedPagination
    if (sortBy === null) {
      //@ts-ignore
      this.updatePagination({ sortBy: index, descending: true })
    } else if (sortBy === index && descending) {
      //@ts-ignore
      this.updatePagination({ descending: false })
    } else if (sortBy !== index) {
      //@ts-ignore
      this.updatePagination({ sortBy: index, descending: true })
      //@ts-ignore
    } else if (!this.mustSort) {
      //@ts-ignore
      this.updatePagination({ sortBy: null, descending: null })
    } else {
      //@ts-ignore
      this.updatePagination({ sortBy: index, descending: true })
    }
  }

  genHeaderSortingData (header: any, children: any, data: any, classes: any) {
      if (!('value' in header)) {
        //console.warn('Headers must have a value property that corresponds to a value in the v-model array', this)
      }

      const vtag = this.$createElement;
      if (this.headerActions?.length){
        const actions = vtag('span', {
            class: {
              'data-table__header_actions': true
            },
            on:{
              click:(ev:any)=>{
                ev.stopPropagation();
              }
            }
          },
          //@ts-ignore
          (this.headerActions.map( (C: any) => {
            return vtag(C, {
              props:{
                data: { header:header, ctx: this}
              }
            }, [])
          })) as any);
  
  
        children.unshift(actions);
      }
          
      if(this.getCustomMetrics(this.$route.name)?.sort_exclude?.includes(header?.value)){
        return
      }
            

      data.attrs.tabIndex = 0;
      data.on = {
        click: () => {
          //@ts-ignore
          this.expanded = {};
          if(header.disableSortChange !== true) {
            this.sort(header.value);
          }
        },
        keydown: (e: any) => {
          // check for space
          if (e.keyCode === 32) {
            e.preventDefault();
            if(header.disableSortChange !== true) {
              this.sort(header.value);
            }
          }
        }
      };

      classes.push('sortable');
      //@ts-ignore
      const icon = vtag('v-icon', {
        props: {
            small: true
        }
        //@ts-ignore
      }, this.sortIcon);

      if (!header.align || header.align === 'left') {
          children.push(icon)
      } else {
          children.unshift(icon)
      }

      //@ts-ignore
      const pagination = this.computedPagination;

      //@ts-ignore
      const beingSorted = pagination.sortBy === header.value;
      if (beingSorted) {
          classes.push('active');
          if (pagination.descending) {
              classes.push('desc');
              data.attrs['aria-sort'] = 'descending';
              data.attrs['aria-label'] += ': Sorted descending. Activate to remove sorting.' // TODO: Localization
          } else {
              classes.push('asc');
              data.attrs['aria-sort'] = 'ascending';
              data.attrs['aria-label'] += ': Sorted ascending. Activate to sort descending.' // TODO: Localization
          }
      } else {
          data.attrs['aria-label'] += ': Not sorted. Activate to sort ascending.' // TODO: Localization
      }
  }

  get colTags() {
    let result: any[] = [];
    if(this.statusColumn) {
      result.push({
        name: 'status',
        width: this.treeLevel === 1 
          ? '43px'
          : this.treeLevel === 2
            ? '58px'
            : '20px'
      });
    }

    if(this.treeView && this.treeView.length) {
      result.push({
        name: 'treview',
        width: '22px'
      });
    } else if(
      this.selectable && 
      //@ts-ignore
      this.hasSelectAll
    ) {
      result.push({
        name: 'checkbox',
        width: '22px'
      });
    }

    const headers = this.processedHeaders.map((header: any)=> {
      const name = this.treeLevel > 0 && this.grouping === header.value 
        ? this.rootGrouping
        : header.value;

      return {
        name: name
      };
    });

    result = result.concat(headers);
    return result;
  }

  genColGroup(scrollbarFiller: boolean = true){
    const vtag: Function = this.$createElement;
    // const a = this.colTags.map((e: any) => ({ n: e.name, w: e.width ? e.width : get(resizerData, e.name, null) }));
    //console.log('this.resizerData', this.resizerData);

    return vtag(
      'colgroup', 
      this.colTags.map((e: any) => vtag('col', {
        key: e.name,
        style: {
          width: e.width ? e.width : get(this.resizerData, e.name, null)
        },
        attrs: {
          'data-key': e.name
        }
      }))
      .concat([vtag('col', {
        key: 'last-column'
      })])
      .concat(
        scrollbarFiller && scrollbarWidth && this.isScrollVisible
          ? [vtag('col', {
              key: 'scrollbar',
              style: {
                width: `${scrollbarWidth}px`
              },
              attrs: {
                'data-key': 'scrollbar'
              }
            })] 
          : []
      )
    );
    //scrollbarWidth
  }

  update() {
    //@ts-ignore
    selectRow(null);
  }

  @Watch('headers')
  onHeadersChanged(value: any[], oldValue: any[]) {
    if(!this.simple) {
      const check = () => {
        if(!oldValue) {
          return true;
        } else {
          const a = value.map((item) => item.value).join();
          const b = oldValue.map((item) => item.value).join();

          if(a !== b) {
            return true;
          }
        }

        return false;
      }
    }
  }

  @Watch('selectedMetrics')
  metricsUpdated(){
    this.update();
  }

  @Watch('header')
  headersUpdated(){
    this.update();
  }

  @Watch('items', {
    immediate: true, 
    deep: true
  })
  itemsUpdated(data: any[]) {
    this.rowColCount = 0;
    
    if(this.treeLevel > 0) {
      this.bus.$emit('tree-items-updated');
    }

    this.scrolledItems = this.generateIds 
      ? data.map((item, index) => Object.assign({ [this.rowKey]: index }, item))
      : this.idPrefix 
        ? data.map((item) => Object.assign({}, item, { [this.rowKey]: `with-prefix:${this.idPrefix}:[${item[this.rowKey]}]` }))
        : data;
      
    this.itemsCount = data.length;
    this.update();
  }

  @Watch('tableTreeLevels') 
  onTableTreeLevelsChanged(val: any, oldVal: any) {
    if(this.isVirtualScroll) {
      this.vTabRevision++;
    }
  }

  get alertsClasses() {
    return this.treeRoot 
      ? {
        [`v-table__overflow_alert-${this.$store.state.alertsCount}`]: true
      } 
      : { };
  }

  get tableOverflow() {
    // console.log('tableOverflow');
    const vtag = this.$createElement;

    let body = this.genTBody();
    
    let data: any[] = [];
    let cols: any[] = [];

    for(let i = 0; i < this.rowColCount; i++) {
      data.push(vtag('td',{key: i} , []));
      
      if(+i < this.rowColCount - 1) {
        cols.push(vtag('col', {key: i}, []));
      }
    }

    data.push(vtag('td', {class: 'datatable-row__right-filler'}));

    return vtag('div', {
      ref: 'overflow',
      class: {
        'v-table__overflow': true,
        'v-table__overflow_activeChart': this.$store.state.table.chartOpen,
        ...this.alertsClasses
      },
          // SCROLL EVENTS
        // on: {
        //   scroll: (ev: MouseEvent)=> {
        //     const overflow: HTMLElement = (ev.target as HTMLElement);
        //     console.log(overflow.scrollHeight, overflow.scrollTop)
        //   }
        // }
      }, 
      [
        vtag('table', {
            'class': {
              //@ts-ignore
              ...this.classes, 
              'v-datatable__main': true
            } 
        }, [
            this.genColGroup(false),
            body,
        ]),
        this.genFiller(cols, data)
      ]
    );
  }

  genFiller(cols: any[], data: any[]): any {
    const vtag = this.$createElement;
    return this.treeRoot 
      ? vtag('div', {'class': 'v-datatable__filler-wrapper'}, [
          vtag('table', {
            class: 'v-datatable v-table v-datatable__filler',
          }, 
          [
            this.genColGroup(),
            vtag('tbody', [
              vtag('tr', data)
            ])
          ])
        ]
      )
      : [];
  }

  cachedTable: any;

  genTable() {
    const h = this.$createElement;

    if (this.treeRoot) {
      return h('div', {
        ref: 'root',
        class: {
          'datatable': true,
          'datatable--has-scrollbar': this.isScrollVisible,
          'datatable--has-footer': this.footer,
          'datatable--active-chart': this.$store.state.table.chartOpen,
          //@ts-ignore
          'datatable--not-have-select-all': !this.hasSelectAll,
          'datatable--fill-height': this.fillHeight !== false,
          'datatable--no-data': this.itemsCount === 0,
        },
        on: {
          mouseup: () => {
            //this.bus.emit('datatable-resizer-redraw');
          } 
        }
      }, [
          h('table', {'class': ['v-datatable v-table datatable-header']}, [
            this.genColGroup(),
            this.THead
          ]),
          this.tableOverflow,
          h('table', {'class': ['v-datatable v-table datatable-footer']}, [
            this.genColGroup(),
            this.genTFoot()
          ]),
          //@ts-ignore
          this.genActionsFooter()
      ]);
    } else {
      return h('div', [
        this.tableOverflow
      ]);
    }
  }

  render () {
    if(!this.cachedTable || !this.freezed) {
      this.cachedTable = this.genTable();
    }
    
    return this.cachedTable
  }
}
